<nz-layout class="main">
  <nz-sider nzCollapsible nzWidth="305px">
    <app-sider></app-sider>
  </nz-sider>
  <nz-layout>
    <nz-content>
      <div class="top-bar">
        <div class="item">
          <span nz-icon nzType="user" nzTheme="outline"></span>
        </div>
        <div class="item">{{ user.nickName }}</div>
        <nz-divider nzType="vertical" style="border-color: #ffffff50"></nz-divider>
        <a nz-dropdown [nzDropdownMenu]="menu">
          {{ role.roleName }}
          <span nz-icon nzType="down"></span>
        </a>
        <!-- nzMenu -->
        <!-- <div class="item">
          <span nz-icon nzType="bell" nzTheme="outline"></span>
        </div>
        <div class="item">
          <span nz-icon nzType="setting" nzTheme="outline"></span>
        </div> -->
        <div class="item">
          <span nz-icon nzType="logout" nzTheme="outline" (click)="logout()"></span>
        </div>
      </div>
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    <li nz-menu-item *ngFor="let role of user.roles">
      <a (click)="changeRole(role)">{{ role.roleCode }}</a>
    </li>
  </ul>
</nz-dropdown-menu>
